import { useState } from 'react';
// components
import BottomSheet from 'cds/bottomsheet';
import CheckButton from 'cds/bottomsheet/buttons/Check';
import FilterDropdown from 'components/atoms/forms/FilterDropdown';

/**@type {Array<{id:number;name:string;sort:string;order:'desc'|'asc'}>} */
const filterMap = [
  { id: 0, name: '참여인기순', sort: 'signup_cnt', order: 'desc' },
  { id: 1, name: '별점높은순', sort: 'review_score', order: 'desc' },
  { id: 2, name: '리뷰많은순', sort: 'review_count', order: 'desc' },
  { id: 3, name: '가격낮은순', sort: 'payment', order: 'asc' },
  { id: 4, name: '가격높은순', sort: 'payment', order: 'desc' },
  { id: 5, name: '최신순', sort: 'class_id', order: 'desc' },
  { id: 6, name: '정확도순', sort: 'match_score', order: 'desc' },
  { id: 7, name: '인기순', sort: 'helpful_cnt', order: 'desc' },
  { id: 8, name: '신규 등록', sort: 'event', order: 'desc' },
  { id: 9, name: '마감 임박', sort: 'event', order: 'asc' },
];

/**
 * 클래스 목록 필터 Hook
 * - 순서를 지정하지 않거나, 빈 배열이면 전체 정렬 리스트가 표시됩니다.
 * @param {number[]} orders 순서
 * @example
 * const {
 * 	currentFilter,
 * 	FilterSheet,
 * 	onFilterShow,
 * 	onFilterHide
 * } = useClassFilter();
 */
const useClassFilter = (orders = []) => {
  const [show, setShow] = useState(false);
  const [filter, setFilter] = useState(orders.length === 0 ? filterMap[0] : filterMap[orders[0]]);

  const onClick = index => {
    setFilter(filterMap[index]);
    setShow(false);
  };

  const onClickByName = name => {
    const [filtered] = filterMap.filter(v => v.name === name);
    if (!filtered) {
      return;
    }

    setFilter(filtered);
    setShow(false);
  };

  const ButtonList =
    orders.length === 0
      ? filterMap.map(order => (
          <CheckButton
            key={order.id}
            message={order.name}
            checked={filter.id === order.id}
            onClick={() => onClick(order.id)}
          />
        ))
      : orders.map(id => (
          <CheckButton
            key={id}
            message={filterMap[id].name}
            checked={filter.id === id}
            onClick={() => onClick(id)}
          />
        ));

  const orderedFilter =
    orders.length === 0 ? filterMap.map(order => order.name) : orders.map(id => filterMap[id].name);

  const FilterSheet = () =>
    show ? <BottomSheet closeCallback={() => setShow(false)}>{ButtonList}</BottomSheet> : null;

  const FilterDropDown = () => (
    <FilterDropdown sortName={filter.name} itemList={orderedFilter} onClickItem={onClickByName} />
  );

  return {
    currentFilter: filter,
    FilterSheet,
    FilterDropdown: FilterDropDown,
    onFilterShow: () => setShow(true),
    onFilterHide: () => setShow(false),
  };
};

export default useClassFilter;
